import { CampaignCounts } from '@models/Campaign'
import { Col, Row } from 'antd'
import { FC } from 'react'
import { CampaignStatistic } from './Statistic'

type Props = {
  loading?: boolean
  counts?: CampaignCounts
}

export const CampaignStatisticRow: FC<Props> = ({ loading, counts }) => {
  return (
    <Row gutter={[16, 16]}>
      <Col span={6}>
        <CampaignStatistic
          loading={loading}
          value={counts?.totalEmployees}
          title="Total employés"
          help="Le nombre d'employés qui participent à la campagne"
        />
      </Col>
      <Col span={6}>
        <CampaignStatistic
          loading={loading}
          value={counts?.totalSignedEmployee}
          compareTo={counts?.totalEmployees}
          title="Réponses employés"
          help="Le nombre d'employés qui ont entièrement complété et signé leur entretien"
        />
      </Col>
      <Col span={6}>
        <CampaignStatistic
          loading={loading}
          value={counts?.totalSignedManager}
          title="Réponses manager"
          help="Le nombre de manager qui ont entièrement complété tous leur entretiens"
        />
      </Col>
      <Col span={6}>
        <CampaignStatistic
          loading={loading}
          value={counts?.totalSigned}
          compareTo={counts?.totalEmployees}
          title="Signés"
          help="Le nombre d'entretien complétés et signés par les deux parties"
        />
      </Col>
    </Row>
  )
}
